<template>
  <main id="outstock" class="page-container" v-if="$route.name === 'orders'">
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->
    <div class="table-container-outstocks">
      <div class="outstocks-toolbar">
        <!-- sc-47879: attivi = da approvvigionare, arrivati = archiviati -->
        <div class="outstock-tabs" role="tablist">
          <button
            class="outstock-tab"
            :class="{ 'outstock-tab--active': !isArchivedTab }"
            role="tab"
            :aria-selected="!isArchivedTab"
            @click="switchTab(false)"
          >
            Da approvvigionare
            <span class="outstock-tab__count">{{ tabCounts.active }}</span>
          </button>
          <button
            class="outstock-tab"
            :class="{ 'outstock-tab--active': isArchivedTab }"
            role="tab"
            :aria-selected="isArchivedTab"
            @click="switchTab(true)"
          >
            Arrivati
            <span class="outstock-tab__count">{{ tabCounts.archived }}</span>
          </button>
        </div>
        <router-link to="/home/orders/add-product" class="primary-btn">
          + Nuovo articolo fuori magazzino
        </router-link>
      </div>
      <div class="tbl-wrap">
        <table ref="fitTable" class="tbl outstock-table">
          <thead>
            <tr>
              <th id="nome-articolo">Nome articolo</th>
              <th id="misura" class="col-secondary">Misura</th>
              <th id="quantity">Quantità/Quantità al Mq</th>
              <th id="sub-category" class="col-secondary">Sottocategoria</th>
              <th id="price" class="col-secondary">Prezzo/Prezzo al Mq</th>
              <th id="delivery-state">Stato approvvigionamento</th>
              <th class="actions-col"></th>
            </tr>
          </thead>
          <tbody>
            <!-- template per generare due <tr> per ogni cliente -->
            <template v-for="(product, index) in allOutstock" :key="index">
              <tr
                class="outstock-row row-clickable"
                @click="onRowClick($event, product)"
              >
                <td>{{ outstockName(product) }}</td>
                <td class="col-secondary">
                  <span :class="measureClass(product)">{{
                    measureLabel(product)
                  }}</span>
                </td>

                <td :class="{ 'qty-none': qtyOf(product) <= 0 }">
                  {{
                    qtyOf(product) <= 0
                      ? "Non è necessario ordinare nulla"
                      : qtyOf(product)
                  }}
                </td>

                <td class="col-secondary">{{ product.subCategory }}</td>
                <td class="col-secondary">
                  {{ showTheRightPrice(product) }}
                </td>
                <td class="state-container">
                  <div class="status-wrapper">
                    <!-- [sc-49210] Pallino solo accanto al badge "Arrivato":
                         l'AppSelect ha già il suo pallino colorato. -->
                    <svg
                      v-if="product.state === 'Arrivato'"
                      :class="[
                        'status-icon-shipping',
                        { on_the_way: product.state !== 'Arrivato' },
                        { delivered: product.state === 'Arrivato' },
                      ]"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                    >
                      <path
                        d="M15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5Z"
                      />
                    </svg>

                    <!-- Arrivato = archiviato: stato definitivo, sola lettura -->
                    <span
                      v-if="product.state === 'Arrivato'"
                      class="status-badge"
                      title="Articolo arrivato e archiviato"
                    >
                      Arrivato
                    </span>
                    <AppSelect
                      v-else
                      v-model="product.state"
                      :options="stateOptions"
                      @change="onStateChange(product, $event)"
                      title="Stato approvvigionamento"
                    />
                  </div>
                </td>
                <td class="actions-cell">
                  <button
                    class="icons-button"
                    @click="showOutstockDetails(product)"
                    title="Dettagli articolo fuori magazzino"
                    aria-label="Dettagli articolo fuori magazzino"
                  >
                    <i class="fa-solid fa-circle-info"></i>
                  </button>
                  <!-- Link verso un percorso di modifica (usa Vue Router) -->
                  <button
                    class="icons-button"
                    @click="goEditOutstock(product.id)"
                    title="Modifica articolo fuori magazzino"
                    aria-label="Modifica articolo fuori magazzino"
                  >
                    <i class="fa-solid fa-pen-to-square"></i>
                  </button>

                  <!-- Pulsante per la cancellazione (chiama un metodo in Vue) -->
                  <button
                    class="icons-button"
                    @click="openArchiveModal(product)"
                    title="Archivia articolo fuori magazzino"
                    aria-label="Archivia articolo fuori magazzino"
                  >
                    <i class="fa-solid fa-trash-can"></i>
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <!-- ⬇️ Barra paginazione + ricerca -->
      <div class="pagination">
        <div class="search-container">
          <input
            type="text"
            v-model="searchTerm"
            @keyup.enter="onSearch"
            placeholder="Cerca articoli fuori magazzino..."
            class="search-box"
          />
          <button
            v-if="searchTerm"
            @click="onResetSearch"
            class="clear-search-button"
          >
            <i class="fa-solid fa-times"></i>
          </button>
        </div>

        <div class="pagination-info">
          {{ pagination.startItem }}-{{ pagination.endItem }} di
          {{ pagination.totalItems }}
        </div>

        <div class="pagination-controls">
          <button
            class="icons-button"
            @click="goToPage(1)"
            :disabled="pagination.currentPage === 1"
            :title="
              pagination.currentPage === 1 ? null : 'Torna alla prima pagina'
            "
          >
            <i class="fa-solid fa-angles-left"></i>
          </button>
          <button
            class="icons-button"
            @click="goToPage(pagination.currentPage - 1)"
            :disabled="pagination.currentPage === 1"
            :title="
              pagination.currentPage === 1
                ? null
                : 'Torna alla pagina precedente'
            "
          >
            <i class="fa-solid fa-chevron-left"></i>
          </button>

          <button
            v-for="pageNum in visiblePages"
            :key="pageNum"
            @click="goToPage(pageNum)"
            :class="{ active: pagination.currentPage === pageNum }"
            class="pages-button"
          >
            {{ pageNum }}
          </button>

          <button
            class="icons-button"
            @click="goToPage(pagination.currentPage + 1)"
            :disabled="pagination.currentPage === pagination.totalPages"
            :title="
              pagination.currentPage === pagination.totalPages
                ? null
                : 'Vai alla pagina successiva'
            "
          >
            <i class="fa-solid fa-chevron-right"></i>
          </button>
          <button
            class="icons-button"
            @click="goToPage(pagination.totalPages)"
            :disabled="pagination.currentPage === pagination.totalPages"
            :title="
              pagination.currentPage === pagination.totalPages
                ? null
                : `Vai all'ultima pagina`
            "
          >
            <i class="fa-solid fa-angles-right"></i>
          </button>
        </div>
      </div>

      <!-- MODALE DETTAGLI ARTICOLO FUORI MAGAZZINO -->
      <VueFinalModal
        v-model="showOutstocksModal"
        :clickToClose="true"
        :escToClose="true"
        classes="documents-modal"
        content-class="outstock-details-modal-content"
      >
        <template #default>
          <button
            class="modal__close icons-button"
            @click="closeOutstocksModal"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>

          <h3 class="modal__title">Dettaglio articolo fuori magazzino</h3>
          <hr />
          <!-- MOSTRA UN SOLO ARTICOLO -->
          <div v-if="selectedOutstock" class="documents-grid">
            <div class="document-card">
              <div class="card-link">
                <div class="card-icon-outstocks">
                  <i class="fa-solid fa-dolly"></i>
                </div>
                <div class="card-body">
                  <div class="card-title">
                    {{ outstockName(selectedOutstock) }}
                  </div>
                  <div class="card-subtitle">
                    <div>
                      <strong>Categoria:</strong>
                      {{ selectedOutstock.category || "—" }}
                    </div>
                    <div>
                      <strong>Sottocategoria:</strong>
                      {{ selectedOutstock.subCategory || "—" }}
                    </div>
                    <div>
                      <strong
                        >{{
                          selectedOutstock.subCategory !== "piastrelle"
                            ? "Quantità"
                            : "Quantità al mq"
                        }}:
                      </strong>
                      <span
                        :class="{ 'qty-none': qtyOf(selectedOutstock) <= 0 }"
                      >
                        {{
                          qtyOf(selectedOutstock) <= 0
                            ? "Non è necessario ordinare nulla"
                            : qtyOf(selectedOutstock)
                        }}
                      </span>
                    </div>
                    <div>
                      <strong
                        >{{
                          selectedOutstock.subCategory !== "piastrelle"
                            ? "Prezzo"
                            : "Prezzo al mq"
                        }}:</strong
                      >
                      {{ showTheRightPrice(selectedOutstock) }}
                    </div>
                    <div>
                      <strong>Stato:</strong> {{ selectedOutstock.state }}
                    </div>
                    <div>
                      <strong>Misura: </strong>
                      <span :class="measureClass(selectedOutstock)">
                        {{ measureLabel(selectedOutstock) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="no-result">Dettaglio non disponibile</div>
        </template>
      </VueFinalModal>

      <!-- MODALE DI ARCHIVIAZIONE -->
      <VueFinalModal
        v-model="showArchiveModal"
        :clickToClose="true"
        :escToClose="true"
        classes="archive-modal"
        content-class="archive-modal-content"
      >
        <template #default>
          <button
            class="modal__close icons-button"
            @click="showArchiveModal = false"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
          <h3 class="modal__title">Archivia articolo fuori magazzino</h3>
          <p class="modal_subtitle">
            Archiviare l'articolo fuori magazzino
            <strong>{{ outstockName(outstockToArchive) }}</strong
            >?
          </p>
          <div class="modal-actions">
            <button
              class="btn btn-secondary"
              @click="closeArchiveModal"
              :disabled="archiving"
            >
              Annulla
            </button>
            <button
              class="btn btn-primary"
              @click="confirmArchive"
              :disabled="archiving"
            >
              {{ archiving ? "Archiviando..." : "Archivia" }}
            </button>
          </div>
        </template>
      </VueFinalModal>

      <!-- MODALE DI CONFERMA CAMBIO STATO GENERICO -->
      <VueFinalModal
        v-model="showConfirmModal"
        :clickToClose="true"
        :escToClose="true"
        classes="archive-modal"
        content-class="archive-modal-content"
      >
        <template #default>
          <button
            class="modal__close icons-button"
            @click="handleConfirmCancel"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
          <h3 class="modal__title">{{ confirmTitle }}</h3>
          <p class="modal_subtitle" v-html="confirmMessage"></p>
          <div class="modal-actions">
            <button
              class="btn btn-secondary"
              @click="handleConfirmCancel"
              :disabled="confirmBusy"
            >
              Annulla
            </button>
            <button
              class="btn btn-primary delivered-confirm"
              @click="handleConfirmOK"
              :disabled="confirmBusy"
            >
              {{ confirmBusy ? "Confermando..." : confirmLabel }}
            </button>
          </div>
        </template>
      </VueFinalModal>

      <!-- [sc-49210] Dettaglio riga: le colonne secondarie -->
      <RowDetailsModal
        v-model="showRowDetails"
        :title="
          rowDetailsProduct ? outstockName(rowDetailsProduct) : 'Articolo'
        "
      >
        <template v-if="rowDetailsProduct">
          <div>
            <dt>Misura</dt>
            <dd>
              <span :class="measureClass(rowDetailsProduct)">{{
                measureLabel(rowDetailsProduct)
              }}</span>
            </dd>
          </div>
          <div>
            <dt>Sottocategoria</dt>
            <dd>{{ rowDetailsProduct.subCategory }}</dd>
          </div>
          <div>
            <dt>
              {{
                rowDetailsProduct.subCategory === "piastrelle"
                  ? "Prezzo al Mq"
                  : "Prezzo"
              }}
            </dt>
            <dd>{{ showTheRightPrice(rowDetailsProduct) }}</dd>
          </div>
        </template>
      </RowDetailsModal>
    </div>
  </main>
  <router-view></router-view>
</template>

<script>
import { mapActions, mapGetters } from "vuex/dist/vuex.cjs.js";
import { formatPriceToPrint } from "../utilities/formatting";
import { outstockName } from "../utilities/itemDescription";
import RowDetailsModal from "@/components/RowDetailsModal.vue";
import { shouldOpenRowDetails } from "@/utilities/rowDetails";
import { outstockStateOptions } from "@/utilities/procurement";
import { fitPageSizeMixin } from "@/utilities/fitPageSize";

export default {
  // [sc-49210] elementi per pagina calcolati dallo schermo (pageSize)
  mixins: [fitPageSizeMixin],
  components: { RowDetailsModal },
  computed: {
    ...mapGetters({
      allOutstock: "outstocks/list",
      pagination: "outstocks/pagination",
      tabCounts: "outstocks/tabCounts",
    }),

    // sc-47879: scheda "Arrivati" = articoli archiviati all'arrivo.
    isArchivedTab() {
      return this.activeTab === "archived";
    },

    visiblePages() {
      const range = 2;
      const start = Math.max(1, (this.pagination.currentPage || 1) - range);
      const end = Math.min(
        this.pagination.totalPages || 1,
        (this.pagination.currentPage || 1) + range
      );
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
  },
  data() {
    return {
      stateOptions: outstockStateOptions, // [sc-49210] con i colori dei pallini
      // outstocks: [],
      errorMessage: "",
      successMessage: "",
      showOutstocksModal: false,
      outstockSearch: "",
      detailedOutstock: [],
      selectedOutstock: null,

      showArchiveModal: false,
      outstockToArchive: null,
      archiving: false,

      showConfirmModal: false,
      confirmTitle: "",
      confirmMessage: "",
      confirmLabel: "Conferma",
      confirmBusy: false,
      pendingStateChange: null, // { id, newState, prevState, product }

      currentPage: 1,
      searchTerm: "",
      activeTab: "active", // sc-47879: "active" | "archived"
      showRowDetails: false,
      rowDetailsProduct: null,
    };
  },
  methods: {
    // [sc-49210] il numero di righe che stanno nello schermo è cambiato
    onPageSizeChange() {
      return this.getOutstocks(1, this.searchTerm);
    },
    ...mapActions([
      "fetchOutstocks",
      "archiveOutstock",
      "fetchOutstockById",
      "updateOutstockState",
    ]),

    formatPriceToPrint,
    outstockName,

    onRowClick(event, product) {
      if (!shouldOpenRowDetails(event)) return;
      this.rowDetailsProduct = product;
      this.showRowDetails = true;
    },

    measureLabel(p) {
      const isTiles = (p.subCategory || "").toLowerCase() === "piastrelle";
      if (!isTiles) return "-";

      const md = (p.measureDesc || "").trim();
      if (!md) return "Non è stata specificata la misura";

      // normalizza: aggiungi " cm" se manca
      return /\bcm\b/i.test(md) ? md : `${md} cm`;
    },
    measureClass(p) {
      const isTiles = (p.subCategory || "").toLowerCase() === "piastrelle";
      // usa la stessa classe di “Non è necessario ordinare nulla”
      return isTiles && !(p.measureDesc || "").trim() ? "qty-none" : "";
    },

    showTheRightPrice(product) {
      // console.log("product", product);
      return product.subCategory === "piastrelle"
        ? product.sqmPrice
        : product.price;
    },

    closeOutstocksModal() {
      this.showOutstocksModal = false;
      // this.detailedOutstock = [];
      // this.outstockSearch = "";
      this.selectedOutstock = null;
    },

    async showOutstockDetails(outstock) {
      try {
        const detail = await this.fetchOutstockById(outstock.id); // azione Vuex
        this.selectedOutstock = detail; // ← oggetto singolo
        this.showOutstocksModal = true;
      } catch (e) {
        console.error(e);
        this.errorMessage =
          "Impossibile caricare i dettagli di questo articolo fuori magazzino.";
        this.$toast.error(this.errorMessage);
      }
    },

    qtyOf(p) {
      return Number(p.quantity ?? p.sqmQuantity ?? 0);
    },

    // sc-47879: cambio scheda attivi/arrivati, si riparte da pagina 1.
    async switchTab(archived) {
      const next = archived ? "archived" : "active";
      if (this.activeTab === next) return;
      this.activeTab = next;
      this.currentPage = 1;
      await this.getOutstocks(1, this.searchTerm);
    },

    async getOutstocks(page = 1, search = this.searchTerm) {
      try {
        const res = await this.fetchOutstocks({
          page,
          limit: this.pageSize,
          search,
          archived: this.isArchivedTab,
        });
        this.currentPage = page;

        // Se arriva 200 ma lista vuota con ricerca attiva
        if (Array.isArray(res) && res.length === 0 && (search || "").trim()) {
          this.errorMessage =
            "Nessun articolo fuori magazzino per la ricerca richiesta.";
          this.$toast.error(this.errorMessage);
        }
      } catch (error) {
        // Se 404 su pagina > 1, prova la prima pagina
        if (error?.response?.status === 404 && page !== 1) {
          try {
            await this.fetchOutstocks({
              page: 1,
              limit: this.pageSize,
              search,
              archived: this.isArchivedTab,
            });
            this.currentPage = 1;
            return;
          } catch (_) {
            /* ignora, gestiamo sotto */
          }
        }

        const defaultMsg =
          search && search.trim()
            ? "Nessun articolo fuori magazzino per la ricerca richiesta."
            : "Non esistono articoli fuori magazzino.";

        this.errorMessage =
          error?.response?.data?.message ||
          error?.response?.data?.details ||
          defaultMsg;

        this.$toast.error(this.errorMessage);
        console.error(error);
      }
    },

    goEditOutstock(outstockId) {
      this.$router.push({ name: "edit-product", params: { outstockId } });
    },

    openArchiveModal(product) {
      this.outstockToArchive = product;
      this.showArchiveModal = true;
    },

    closeArchiveModal() {
      this.showArchiveModal = false;
      this.outstockToArchive = null;
    },

    async confirmArchive() {
      const id = this.outstockToArchive?.id;
      if (!id) return;

      try {
        await this.archiveOutstock(id);
        this.successMessage =
          "Articolo fuori da magazzino archiviato con successo.";
        this.$toast.success(this.successMessage);
        this.errorMessage = "";
      } catch (err) {
        console.error(err);
        this.errorMessage =
          "Impossibile archiviare l'articolo fuori da magazzino.";
        this.$toast.error(this.errorMessage);

        this.successMessage = "";
      } finally {
        this.showArchiveModal = false;
        this.outstockToArchive = null;
        // ricarica elenco mantenendo pagina e filtro correnti
        await this.getOutstocks(this.currentPage, this.searchTerm);
      }
    },

    // sc-47879: "Arrivato" archivia l'articolo ed è irreversibile → conferma.
    // Gli altri passaggi si applicano direttamente.
    async onStateChange(product, value) {
      const prevState = this.stateBeforeChange(product, value);

      if (value === "Arrivato") {
        this.pendingStateChange = {
          id: product.id,
          newState: value,
          prevState,
          product,
        };
        const name = outstockName(product);
        this.confirmTitle = "Conferma arrivo";
        this.confirmMessage =
          `Segnare come <strong>"Arrivato"</strong> l'articolo <strong>${name}</strong>? ` +
          `Verrà spostato tra gli archiviati e lo stato non sarà più modificabile.`;
        this.confirmLabel = "Conferma";
        this.showConfirmModal = true;
        return;
      }

      await this.applyStateChange(product, value, prevState);
    },

    // v-model ha già scritto il nuovo valore sulla riga: lo stato precedente
    // si ricava dagli altri due possibili.
    stateBeforeChange(product, value) {
      return value === "Ordinato" ? "Da Ordinare" : "Ordinato";
    },

    async applyStateChange(product, value, prevState) {
      this.successMessage = "";
      this.errorMessage = "";
      try {
        await this.updateOutstockState({
          outstockId: product.id,
          state: value,
        });
        this.successMessage = `Stato aggiornato a "${value}".`;
        this.$toast.success(this.successMessage);
        await this.getOutstocks(this.currentPage, this.searchTerm);
      } catch (err) {
        product.state = prevState;
        this.errorMessage =
          err?.response?.data?.message ||
          err?.response?.data?.details ||
          "Impossibile aggiornare lo stato dell'articolo fuori magazzino.";
        this.$toast.error(this.errorMessage);
        console.error("Errore cambio stato outstock:", err);
        await this.getOutstocks(this.currentPage, this.searchTerm);
      }
    },

    async onSearch() {
      this.currentPage = 1;
      try {
        const res = await this.fetchOutstocks({
          page: 1,
          limit: this.pageSize,
          search: this.searchTerm,
          archived: this.isArchivedTab,
        });

        // In caso (raro) di 200 con lista vuota
        if (
          Array.isArray(res) &&
          res.length === 0 &&
          (this.searchTerm || "").trim()
        ) {
          this.errorMessage =
            "Nessun articolo fuori magazzino per la ricerca richiesta.";
          this.$toast.error(this.errorMessage);
        } else {
          this.successMessage = "Premi 'Esc' per resettare la ricerca.";
          this.errorMessage = "";
        }
      } catch (err) {
        this.errorMessage =
          err?.response?.data?.message ||
          err?.response?.data?.details ||
          "Nessun articolo fuori magazzino per la ricerca richiesta.";
        this.$toast.error(this.errorMessage);
      }
    },

    async onResetSearch() {
      this.searchTerm = "";
      this.currentPage = 1;
      this.successMessage = "";
      this.errorMessage = "";
      try {
        await this.fetchOutstocks({
          page: 1,
          limit: this.pageSize,
          search: "",
          archived: this.isArchivedTab,
        });
      } catch (err) {
        this.errorMessage =
          err?.response?.data?.message ||
          err?.response?.data?.details ||
          "Errore durante il reset della ricerca.";
        this.$toast.error(this.errorMessage);
      }
    },

    async goToPage(page) {
      if (page < 1 || page > (this.pagination.totalPages || 1)) return;
      await this.getOutstocks(page);
    },

    handleConfirmCancel() {
      // Ripristina selezione se l'utente annulla
      if (this.pendingStateChange?.product) {
        this.pendingStateChange.product.state =
          this.pendingStateChange.prevState;
      }
      this.pendingStateChange = null;
      this.showConfirmModal = false;
    },

    async handleConfirmOK() {
      const change = this.pendingStateChange;
      if (!change) return;

      this.confirmBusy = true;
      try {
        await this.applyStateChange(
          change.product,
          change.newState,
          change.prevState
        );
      } finally {
        this.confirmBusy = false;
        this.showConfirmModal = false;
        this.pendingStateChange = null;
      }
    },
  },

  watch: {
    $route(to, from) {
      if (to.name === "orders" && from.name !== "orders") {
        this.getOutstocks(this.currentPage, this.searchTerm);
      }
    },
  },
  mounted() {
    this.getOutstocks(this.currentPage, this.searchTerm).then(() =>
      this.fitPageSize()
    );
  },
};
</script>

<style src="@/css/OutstockPage.css" />
